import {VeBoxCard} from "../../../components/card/VeBoxCard";
import * as React from "react";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {Display} from "../../../components/Display";
import {Loader} from "../../../components/Utils/loader/Loader";
import "./styles.scss"
import {ConfigurationHistoryElement} from "../../widgets/ConfigurationHistoryElement";
import {capitalizeFirstLetter, filterHistoryData, getFormattedDate} from "../../ReadAndWrite/utils";
import {accordionStyle} from "../../ReadAndWrite";
import {Theme} from "@vebox/etui-themes";
import {useTheme} from "@vebox/etui-system";
import {CurrentSettingsUpdateResult} from "../../data/models/CurrentSettingsUpdateResult";
import {STATUS_TEXTS, StatusChip} from "../../components/StatusChip";
import {useSettingsUpdatesResults} from "../../data/hooks/ReadAndWriteControllerHooks";
import {Accordion, AccordionSection, EmptyState, infoIcons} from "@vebox/etui-core";

export const ConfigurationHistoryPage: React.FC = () => {
    const {historyFilterText, getStatusText, AppTranslations, deviceGuid, deviceSlaveSettings, availableRegisters} = React.useContext(
        ReadAndWriteContext);
    const settingsUpdateResults = useSettingsUpdatesResults(deviceGuid);
    const {data, isLoading} = settingsUpdateResults;

    const theme = useTheme();

    const getStartedAt = (data: CurrentSettingsUpdateResult) => {
        return AppTranslations.readAndWrite.configurationStartedAt
            .replace("{0}", data?.startedAt
                ? getFormattedDate({dateToFormat: data?.startedAt})
                : "-")
            .replace("{1}", data?.user);
    }

    const getConcludedAt = (data: CurrentSettingsUpdateResult) => {
        const concluded = AppTranslations.readAndWrite.configurationEndedAt
            .replace("{0}", data?.concludedAt
                ? getFormattedDate({dateToFormat: data?.concludedAt})
                : "-")
        return `${data?.concludedAt ? concluded : ""}`;
    }

    const renderHeaderFarItem = (status: string) => () => {
        return <StatusChip status={capitalizeFirstLetter(status) as STATUS_TEXTS}/>
    }

    const dataSource: JSX.Element[ ] = React.useMemo(() => {
        return (data as CurrentSettingsUpdateResult[] ?? [])
            .filter((_,
                     index) => index !== 0 || (!deviceSlaveSettings?.data.updating && !deviceSlaveSettings?.data.validating))
            .filter(filterHistoryData(historyFilterText, getStatusText))?.map((updateResult, index) => {
                    const minHeight = 37;
                    const changesNumber = updateResult?.changes?.length;
                    const anomaliesNumber = updateResult?.anomalies?.length;
                    const height = (minHeight + ((changesNumber + anomaliesNumber) * 24)) + "px";
                    return <AccordionSection
                        defaultOpen={index === 0 || historyFilterText !== ""}
                        key={index}
                        name={`${getStartedAt(updateResult)} - ${getConcludedAt(updateResult)}`}
                        styles={{
                            ...accordionStyle(theme as Theme),
                            sectionContent: {height: height}
                        }}
                        renderHeaderFarItem={renderHeaderFarItem(updateResult?.status)}
                    >
                        <ConfigurationHistoryElement updateResult={updateResult} key={index} availableRegisters={availableRegisters?.data ?? []}/>
                    </AccordionSection>

                }
            )
    }, [data, historyFilterText]);

    return (
        <div className={"settings-main-container"}>
            <Display isVisible={isLoading}>
                <div>
                    <Loader relativelyCentered={true}/>
                </div>
            </Display>
            <Display isVisible={!isLoading && data?.length > 0}>
                <VeBoxCard className={"Section rw-card "}>
                    <VeBoxCard.Body className={"rw-card-body no-padding"}>
                        <Accordion>
                            {dataSource}
                        </Accordion>
                    </VeBoxCard.Body>
                </VeBoxCard>
            </Display>
            <Display isVisible={!isLoading && data?.length === 0}>
                <VeBoxCard className={"Section rw-card"}>
                    <VeBoxCard.Body className={"rw-card-body"}>
                        <EmptyState>
                            <EmptyState.InfoIcon
                                styles={{
                                    root: {
                                        color: "inherit",
                                    }
                                }}
                                glyph={infoIcons.NoContent}
                            />
                            <EmptyState.Title color="inherit">{AppTranslations.listManager.descriptionNoElement}</EmptyState.Title>
                            <EmptyState.SubTitle color="inherit">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                        </EmptyState>
                    </VeBoxCard.Body>
                </VeBoxCard>
            </Display>
        </div>
    );
};


